import gql from 'graphql-tag';

import remoteItemFromProviderFragment from './remoteItemFromProviderFragment';

export const boxRemoteItemsPageFragment = gql`
  fragment boxRemoteItemsPageFragment on BoxRemoteItemsPage {
    dokkioClass
    nextMarker
    remoteItems {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
export default boxRemoteItemsPageFragment;
